<div class="player" [matMenuTriggerFor]="player" #menuTrigger="matMenuTrigger">
  <div class="gap-2 controls" (click)="$event.stopPropagation()">
    <app-button [btnType]="'icon'" (onChangeClick)="onClearAudio()">
      <app-icon class="player-controls-color">close</app-icon>
    </app-button>

    <app-button [disabled]="currentIndex === 0" [btnType]="'icon'" (onChangeClick)="onChangeAudio(false)">
      <app-icon class="player-controls-color">skip_previous</app-icon>
    </app-button>

    <app-button [btnType]="'icon'" (onChangeClick)="onChangePlay()">
      <app-icon class="player-controls-color">{{ audioService.isPlay ? 'pause' : 'play_arrow' }}</app-icon>
    </app-button>

    <app-button
      [ngClass]="{
        'cursor-disabled': currentIndex === this.audioService.audioSource.length - 1,
      }"
      [disabled]="currentIndex === this.audioService.audioSource.length - 1"
      [btnType]="'icon'"
      (onChangeClick)="onChangeAudio(true)"
    >
      <app-icon class="player-controls-color">skip_next</app-icon>
    </app-button>
  </div>
  <div class="player-controls-color d-flex align-items-center px-2 cursor-pointer">
    @if (menuTrigger.menuOpen) {
      <app-icon>{{ !baseService.isMobile ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</app-icon>
    }
    @if (!menuTrigger.menuOpen) {
      <app-icon>{{ !baseService.isMobile ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</app-icon>
    }
  </div>
</div>

<audio
  #audio
  [hidden]="true"
  [src]="audioService.currentAudio || audioService.audioSource[0]"
  [controls]="true"
  autoplay
></audio>

<mat-menu class="custom-menu mt-2" #player>
  <div class="gap-2 controls d-flex justify-content-center" (click)="$event.stopPropagation()">
    <app-button [btnType]="'icon'" (onChangeClick)="onRewind(false)">
      <app-icon class="player-controls-color">replay_5</app-icon>
    </app-button>

    <app-button
      [ngClass]="{ 'cursor-disabled': currentIndex === 0 }"
      [disabled]="currentIndex === 0"
      [btnType]="'icon'"
      (onChangeClick)="onChangeAudio(false)"
    >
      <app-icon class="player-controls-color">skip_previous</app-icon>
    </app-button>

    <app-button [btnType]="'icon'" (onChangeClick)="onChangePlay()">
      <app-icon class="player-controls-color">{{ audioService.isPlay ? 'pause' : 'play_arrow' }}</app-icon>
    </app-button>

    <app-button
      [ngClass]="{
        'cursor-disabled': currentIndex === this.audioService.audioSource.length - 1,
      }"
      [disabled]="currentIndex === this.audioService.audioSource.length - 1"
      [btnType]="'icon'"
      (onChangeClick)="onChangeAudio(true)"
    >
      <app-icon class="player-controls-color">skip_next</app-icon>
    </app-button>

    <app-button [btnType]="'icon'" (onChangeClick)="onRewind(true)">
      <app-icon class="player-controls-color">forward_5</app-icon>
    </app-button>
  </div>
  <div (click)="$event.stopPropagation()">
    <div class="custom-width p-2" style="width: 660px; max-width: 100%">
      <div class="time">
        <span #currentTime class="text-dark user-select-none">00:00:00</span>
        <div class="progress-bar-audio player-progress-color">
          <div #progressBar class="progress-audio"></div>
        </div>
        <div class="progress-container">
          <div class="progress-bar-container">
            <div class="progress-bar" [style.width.%]="progress"></div>
          </div>
          <input
            class="progress-slider"
            type="range"
            id="progress-slider"
            min="0"
            max="100"
            step="0.01"
            [value]="progress"
            (input)="updateProgress($event)"
            (change)="setProgress($event)"
          />
        </div>
        <span #duration class="text-dark user-select-none">--:--:--</span>
      </div>
    </div>
    <div class="volume-control px-2">
      <app-icon (click)="onValueMute()">{{ checkAudioVolume() }}</app-icon>
      <input #volume type="range" min="0" max="1" step="0.01" class="range" (input)="onVolumeChange($event)" />
    </div>
  </div>
</mat-menu>
